import { createObservability } from '@alice-health/observability'

import { hasCookieConsent } from '@/global/hooks/useCookieConsent/hasCookieConsent'

import pkg from '../../../../package.json'

const DATADOG_CONSENT_CATEGORY = 'performance'

const getTrackingConsent = () =>
  hasCookieConsent(DATADOG_CONSENT_CATEGORY)
    ? ('granted' as const)
    : ('not-granted' as const)

const initObservability = () => {
  const trackingConsent = getTrackingConsent()

  // The lib does not forward customOptions to datadogLogs.init, so Logs gets
  // its consent here, before init: a value set before init wins over the option.
  window.DD_LOGS?.setTrackingConsent(trackingConsent)

  const instance = createObservability({
    defaultProviders: ['DATADOG'],
    providerConfig: {
      datadog: {
        env: process.env.NEXT_PUBLIC_APP_TARGET ?? '',
        service:
          process.env.NEXT_PUBLIC_APP_OBSERVABILITY_APPLICATION_NAME ?? '',
        clientToken:
          process.env.NEXT_PUBLIC_APP_OBSERVABILITY_CLIENT_TOKEN ?? '',
        applicationId:
          process.env.NEXT_PUBLIC_APP_OBSERVABILITY_APPLICATION_ID ?? '',
        customOptions: {
          version: pkg.version,
          trackingConsent
        }
      },
      eventApi: {
        namespace: 'site.alice',
        version: pkg.version,
        apiUrl: process.env.NEXT_PUBLIC_APP_EVENT_API_URL ?? '',
        apiKey: process.env.NEXT_PUBLIC_APP_EVENT_API_KEY ?? ''
      }
    }
  })

  // Cookie-Script fires this on load with a stored choice and on every change,
  // so a late grant starts collection and a revocation stops it.
  window.addEventListener('CookieScriptCurrentState', () => {
    const consent = getTrackingConsent()

    window.DD_RUM?.setTrackingConsent(consent)
    window.DD_LOGS?.setTrackingConsent(consent)
  })

  return instance
}

const observability =
  globalThis.window === undefined ? undefined : initObservability()

export { observability }
